module.exports = __webpack_public_path__ + "img/LeatherJacket.bc6acdf9.gif";